<mat-dialog-content>
  <form-viewer #formViewer
    [dataContainerService]='datasetACS'
    [formConfig]='formConfig'
  ></form-viewer>
</mat-dialog-content>
<mat-dialog-actions>
  <button [disabled]="loading" mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">
    {{'invia' | translate}}
  </button>

  @if (loading) {
    <mat-spinner diameter="20" style="margin-left: 30px;"></mat-spinner>
  }
  <!--<button mat-raised-button mat-dialog-close tabindex="-1">chiudi</button>-->
</mat-dialog-actions>